import SEO from '../components/SEO';
import DeveloperToolsPanel from '../components/DeveloperToolsPanel';

export default function DevToolsHub() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "JsonToonCraft Developer Tools",
    "applicationCategory": "DeveloperApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "description": "A comprehensive suite of 10 essential developer utilities including JWT debugger, JSON formatter, Base64 encoder, timestamp converter, and more. All tools work offline with complete privacy.",
    "featureList": [
      "Decode and inspect JWT tokens instantly",
      "Format and minify JSON data with validation",
      "Encode and decode Base64 strings",
      "Convert between Unix timestamps and human-readable dates",
      "Encode and decode URL components",
      "Generate unique identifiers (v4 UUIDs)",
      "Generate SHA-256, SHA-384, and SHA-512 cryptographic hashes",
      "Generate realistic test user data",
      "Convert between YAML and JSON formats",
      "Convert environment variable files to YAML format"
    ]
  };

  return (
    <>
      <SEO
        title="Developer Tools | JsonToonCraft - 10 Essential Utilities"
        description="Free developer tools including JWT Debugger, JSON Formatter, Base64 Encoder/Decoder, UUID Generator, Hash Generator, and more. All tools work offline with no data collection."
        keywords="developer tools, JWT debugger, JSON formatter, Base64 encoder, UUID generator, hash generator, timestamp converter, URL encoder, mock data generator, YAML converter"
        canonicalUrl="https://jsontooncraft.com/dev-tools"
        structuredData={structuredData}
      />

      <DeveloperToolsPanel />
    </>
  );
}
